import type { iconComponents } from '../../components/Core/IconImports';
import type { FileSecretFieldType } from '../../interfaces/FileSecret';

/** Shared type → Icon name + i18n label for Select options and view-mode rows. */
export interface SecretFieldTypeMeta {
  value: FileSecretFieldType;
  labelKey: string;
  iconName: keyof typeof iconComponents;
}

export const SECRET_FIELD_TYPES: readonly SecretFieldTypeMeta[] = [
  { value: 'text', labelKey: 'secret.types.text', iconName: 'TypeIcon' },
  { value: 'password', labelKey: 'secret.types.password', iconName: 'KeyIcon' },
  { value: 'url', labelKey: 'secret.types.url', iconName: 'LinkIcon' },
  { value: 'username', labelKey: 'secret.types.username', iconName: 'UserIcon' },
  { value: 'email', labelKey: 'secret.types.email', iconName: 'MailIcon' },
  { value: 'phone', labelKey: 'secret.types.phone', iconName: 'PhoneIcon' },
  { value: 'textarea', labelKey: 'secret.types.textarea', iconName: 'ScanTextIcon' },
  { value: 'number', labelKey: 'secret.types.number', iconName: 'HashIcon' },
  { value: 'month', labelKey: 'secret.types.month', iconName: 'CalendarFoldIcon' },
  { value: 'year', labelKey: 'secret.types.year', iconName: 'CalendarFoldIcon' },
];

/** Unknown runtime type → text widget (forward-compat). */
export function getSecretFieldTypeMeta(type: FileSecretFieldType | string): SecretFieldTypeMeta {
  return SECRET_FIELD_TYPES.find((entry) => entry.value === type) ?? SECRET_FIELD_TYPES[0]!;
}
